import { createRouter, createWebHistory } from "vue-router"

// Importar tus vistas
import LoginForm from "../components/LoginForm.vue"
import HomeWeb from "../components/Web/Home.vue"
import PaquetesWeb from "../components/Web/PaquetesWeb.vue"
import AsesoriasWeb from "../components/Web/AsesoriasWeb.vue"
import HomeDash from "../components/Dashboard/HomeDash.vue"
import ReservationsDash from "../components/Dashboard/Reservations.vue"
import PorfileDash from "../components/Dashboard/PorfileDash.vue"
import PaquetesDash from "../components/Dashboard/Paquetes.vue"
import GifTableDash from "../components/Dashboard/GifTableDash.vue"
import GifsTableUser from "../components/Dashboard/GifsTableUser.vue"
import PaqueteDetalle from "../components/Web/Paquete.vue"
import MesaRegalos from "../components/Web/MesaRegalos.vue"

const routes = [
  {
    path: "/login",
    name: "Login",
    component: LoginForm,
    meta: { requiresGuest: true, title: 'Login | BeauVoyage' }
   
  },
  {
    path: "/",
    name: "HomeWeb",
    component: HomeWeb,
    meta: { requiresGuest: true, title: 'BeauVoyage' }
    
  },
  {
    path: "/Paquetes",
    name: "PaquetesWeb",
    component: PaquetesWeb,
    meta: { requiresGuest: true, title: 'Paquetes | BeauVoyage' }
    
  },
  {
    path: "/Asesorias",
    name: "AsesoriasWeb",
    component: AsesoriasWeb,
    meta: { requiresGuest: true, title: 'Asesorías | BeauVoyage' }
    
  },
  {
    path: "/Dashboard",
    name: "HomeDash",
    component: HomeDash,
    meta: { requiresAuth: true, title: 'Dashboard | BeauVoyage' }
  },
  {
    path: "/Reservations",
    name: "ReservationsDash",
    component: ReservationsDash,
    meta: { requiresAuth: true, title: 'Reservaciones | BeauVoyage' }
  },
   {
    path: "/Porfile",
    name: "PorfileDash",
    component: PorfileDash,
    meta: { requiresAuth: true, title: 'Mi perfil | BeauVoyage' }
  },
  {
    path: "/paquetesDash",
    name: "paquetesDash",
    component: PaquetesDash,
    meta: { requiresAuth: true, title: 'Paquetes | BeauVoyage' }
  },
  {
    path: "/MesaDeRegaloAlta",
    name: "GifTableDash",
    component: GifTableDash,
    meta: { requiresAuth: true, title: 'Registro de mesa de regalos | BeauVoyage' }
  },
   {
    path: "/MisMesas",
    name: "GifsTableUser",
    component: GifsTableUser,
    meta: { requiresAuth: true, title: 'Mis mesas de regalo | BeauVoyage' }
  },
  {
  path: "/Paquete/:id",
  name: "PaqueteDetalle",
  component:PaqueteDetalle,
  meta: { requiresGuest: true, title: 'Detalle de paquete | BeauVoyage' }
  },
   {
  path: "/MesaRegalos",
  name: "MesaRegalos",
  component:MesaRegalos,
  meta: { requiresGuest: true, title: 'Mesa de regalos | BeauVoyage' }
  }
  
  
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// 🔒 Middleware para proteger rutas
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem("token")
    
  if (to.meta.requiresAuth && !token) {
    // necesita login pero no hay token
    next("/login");
  } else if (to.meta.requiresGuest && token) {
    // ya tiene token, no debe ir a login ni home
    next("/Dashboard");
  } else {
    next();
  }
})
router.afterEach((to) => {
  if (to.meta && to.meta.title) {
    document.title = to.meta.title
  }
})

export default router
